import React, { useState, useEffect } from 'react';
import icons from '../../img/icons/icons';

// --- Interfaces de Tipagem ---
interface IconProps {
  className?: string;
  size?: number | string;
  color?: string;
}

interface NavLinkProps {
  href: string;
  children: React.ReactNode;
}

// --- Componentes de Ícones (SVG Nativo) ---
const IconAward = ({ className, size = 24, color = "currentColor" }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="8" r="6" />
    <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
  </svg>
);

const IconBuilding = ({ className, size = 24, color = "currentColor" }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <rect width="16" height="20" x="4" y="2" rx="2" ry="2" />
    <path d="M9 22v-4h6v4" />
    <path d="M8 6h.01" />
    <path d="M16 6h.01" />
    <path d="M8 10h.01" />
    <path d="M16 10h.01" />
    <path d="M8 14h.01" />
    <path d="M16 14h.01" />
  </svg>
);

const IconSearch = ({ className, size = 24, color = "currentColor" }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const IconShieldCheck = ({ className, size = 24, color = "currentColor" }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);

const IconDatabase = ({ className, size = 24, color = "currentColor" }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <ellipse cx="12" cy="5" rx="9" ry="3" />
    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
    <path d="M3 12c0 1.66 4 3 9 3s9-1.34 9-3" />
  </svg>
);

const IconChevronRight = ({ className, size = 24, color = "currentColor" }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="m9 18 6-6-6-6" />
  </svg>
);

const IconChevronLeft = ({ className, size = 24, color = "currentColor" }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="m15 18-6-6 6-6" />
  </svg>
);

const IconMenu = ({ className, size = 24, color = "currentColor" }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <line x1="4" x2="20" y1="12" y2="12" />
    <line x1="4" x2="20" y1="6" y2="6" />
    <line x1="4" x2="20" y1="18" y2="18" />
  </svg>
);

const IconX = ({ className, size = 24, color = "currentColor" }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);

const IconCheck = ({ className, size = 24, color = "currentColor" }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

// --- Subcomponentes ---
const NavLink: React.FC<NavLinkProps> = ({ href, children }) => (
  <a href={href} className="nav-link">
    {children}
  </a>
);

// --- Componente Principal ---
const ProjetoCapacita: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [scrolled, setScrolled] = useState<boolean>(false);
  const [currentSlide, setCurrentSlide] = useState<number>(0);

  const historySlides = [
    {
      year: "2023",
      title: "Edição Outono",
      description: "Mais de 120 jovens capacitados e 15 empresas conectadas em apenas 3 meses.",
      image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&q=80&w=1000"
    },
    {
      year: "2022",
      title: "Expansão Regional",
      description: "O projeto atingiu a marca histórica de 85% de índice de contratação pós-curso.",
      image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=1000"
    },
    {
      year: "2021",
      title: "Início do Legado",
      description: "Nasce a parceria entre Newzape e o comércio local para qualificar a mão de obra de Palmeira.",
      image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=1000"
    }
  ];

  useEffect(() => {
    const handleScroll = (): void => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === historySlides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? historySlides.length - 1 : prev - 1));
  };

  return (
    <div className="projeto-capacita-wrapper">
      <style dangerouslySetInnerHTML={{ __html: `
        :root {
          --primary: #003E78;
          --primary-dark: #1e3a8a;
          --secondary: #0089A2;
          --slate-50: #f8fafc;
          --slate-100: #f1f5f9;
          --slate-200: #e2e8f0;
          --slate-400: #94a3b8;
          --slate-600: #475569;
          --slate-900: #0f172a;
          --white: #ffffff;
          --blue-100: #dbeafe;
          --blue-200: #bfdbfe;
          
          /* Fontes do seu projeto */
          --font-header: 'Bebas Neue', cursive;
          --font-body: 'Open Sans', sans-serif;
          --font-accent: 'Comic Neue', cursive;
        }

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .projeto-capacita-wrapper {
          background-color: var(--white);
          font-family: var(--font-body);
          color: var(--slate-900);
          overflow-x: hidden;
          min-height: 100vh;
        }

        .max-container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 1.5rem;
        }

        .logoCapacita{
          width: 500px;
        }

        /* Heading Defaults - BEBAS NEUE BOLD ATIVO */
        h1, h2, h3, h4, .logo-text, .nav-link, .btn-nav, .btn-main, .section-title, .step-num, .year-badge {
          font-family: var(--font-header);
          font-weight: 700 !important;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        /* Navbar Styles */
        nav {
          position: fixed;
          width: 100%;
          z-index: 50;
          transition: all 0.3s ease;
          padding: 1.5rem 0;
        }

        nav.scrolled {
          background-color: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          padding: 0.75rem 0;
        }

        .nav-inner {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .logo-box {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .logo-icon {
          background-color: var(--primary);
          padding: 0.4rem;
          border-radius: 0.5rem;
          color: white;
          display: flex;
        }

        .logo-text {
          font-size: 2rem;
        }

        .logo-text span { color: var(--primary); font-style: italic; }

        .nav-links { display: none; }
        @media (min-width: 1024px) {
          .nav-links { display: flex; align-items: center; gap: 2.5rem; }
        }

        .nav-link {
          font-size: 1.25rem;
          color: var(--slate-600);
          text-decoration: none;
          transition: color 0.2s;
        }

        .nav-link:hover { color: var(--primary); }

        .btn-nav {
          font-size: 1.15rem;
          background-color: var(--primary);
          color: white;
          padding: 0.6rem 1.75rem;
          border-radius: 9999px;
          text-decoration: none;
          box-shadow: 0 10px 15px -3px rgba(59, 130, 246, 0.3);
          transition: all 0.2s;
        }

        .btn-nav:hover { background-color: var(--slate-900); }

        /* Hero Section */
        .hero {
          padding: 10rem 0 5rem;
          background-color: var(--slate-50);
          border-bottom: 1px solid var(--slate-100);
          position: relative;
        }

        .grid-2 {
          display: grid;
          gap: 4rem;
          align-items: center;
        }
        @media (min-width: 1024px) { .grid-2 { grid-template-columns: 1fr 1fr; } }

        .badge-hero {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background-color: var(--blue-100);
          color: var(--primary);
          padding: 0.5rem 1rem;
          border-radius: 9999px;
          font-family: var(--font-accent);
          font-weight: 700;
          font-size: 0.85rem;
          margin-bottom: 2rem;
        }

        h1 {
          font-size: clamp(4rem, 10vw, 6.5rem);
          line-height: 0.9;
          letter-spacing: 0.02em;
          margin-bottom: 0.25rem;
        }

        .hero-subtitle {
          font-size: clamp(1.5rem, 4vw, 2.8rem);
          color: var(--slate-400);
          margin-bottom: 2rem;
          letter-spacing: 0.05em;
          font-style: italic;
          line-height: 1;
        }

        h1 .text-blue { color: var(--primary); font-style: italic; }

        .hero-desc {
          font-size: 1.15rem;
          line-height: 1.6;
          color: var(--slate-600);
          max-width: 32rem;
          margin-bottom: 3rem;
          font-family: var(--font-body);
        }

        .cta-group {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .btn-main {
          padding: 0.75rem 3.5rem; /* Menos altura e mais largura */
          border-radius: 1rem;
          font-size: 1.6rem;
          transition: all 0.3s;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 0.75rem;
          cursor: pointer;
        }

        .btn-main.primary {
          background-color: var(--primary);
          color: white;
          border: none;
          box-shadow: 0 15px 30px -10px rgba(59, 130, 246, 0.4);
        }

        .btn-main.outline {
          background-color: transparent;
          color: var(--slate-900);
          border: 2px solid var(--slate-900);
        }

        .btn-main:hover { transform: translateY(-2px); }

        /* Nova Seção: Certificação Premium e Plataforma */
        .certificacao-premium {
          padding: 8rem 0;
          background-color: var(--white);
        }

        .platform-container {
          background: var(--slate-900);
          border-radius: 4rem;
          padding: 5rem;
          color: white;
          position: relative;
          overflow: hidden;
        }

        .platform-grid {
          display: grid;
          gap: 4rem;
          align-items: center;
        }
        @media (min-width: 1024px) { .platform-grid { grid-template-columns: 1fr 1fr; } }

        .platform-content h2 { font-size: clamp(3rem, 5vw, 4.5rem); margin-bottom: 1.5rem; line-height: 0.9; }
        .platform-content p { font-size: 1.2rem; color: var(--slate-400); margin-bottom: 3rem; line-height: 1.6; max-width: 35rem; }

        .employer-perks {
          display: grid;
          gap: 2rem;
        }

        .perk-card {
          background: rgba(255, 255, 255, 0.05);
          padding: 2rem;
          border-radius: 2rem;
          border: 1px solid rgba(255, 255, 255, 0.1);
          transition: 0.3s;
        }

        .perk-card:hover { background: rgba(255, 255, 255, 0.08); transform: translateX(10px); }

        .perk-header { display: flex; align-items: center; gap: 1.5rem; margin-bottom: 1rem; }
        .perk-icon { 
          background: var(--primary); 
          color: white; 
          padding: 0.75rem; 
          border-radius: 1rem; 
          display: flex;
        }
        .perk-header h3 { font-size: 1.5rem; letter-spacing: 0.05em; color: white; }
        .perk-card p { font-family: var(--font-body); color: var(--slate-400); font-size: 0.95rem; margin-bottom: 0; }

        /* Camiseta Section */
        .camiseta-section { padding: 8rem 0; background-color: var(--slate-50); }
        .camiseta-img-box {
          background-color: var(--blue-100);
          border-radius: 4rem;
          aspect-ratio: 4/5;
          overflow: hidden;
          position: relative;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.1);
        }

        .camiseta-img-box img { width: 100%; height: 100%; object-fit: cover; transition: 0.5s; }
        .camiseta-img-box:hover img { transform: scale(1.05); }

        .logo-placeholder {
          position: absolute;
          top: 50%; left: 50%;
          transform: translate(-50%, -50%) rotate(6deg);
          background-color: rgba(255, 255, 255, 0.9);
          padding: 1rem 2rem;
          border-radius: 1rem;
          box-shadow: 0 10px 25px rgba(0,0,0,0.2);
          text-align: center;
        }

        /* Historico Slider */
        .historico { padding: 8rem 0; }
        .slider-wrapper { position: relative; overflow: hidden; }
        .slider-track { display: flex; transition: transform 0.7s ease-in-out; }
        .slide { min-width: 100%; padding: 0.5rem; }
        .slide-content-box {
          background: var(--slate-50); border-radius: 4rem; overflow: hidden;
          display: flex; flex-direction: column;
        }
        @media (min-width: 1024px) { .slide-content-box { flex-direction: row; height: 500px; } }
        
        .slide-img { width: 100%; height: 300px; position: relative; }
        @media (min-width: 1024px) { .slide-img { width: 50%; height: 100%; } }
        .slide-img img { width: 100%; height: 100%; object-fit: cover; }

        .slide-text-side { padding: 4rem; display: flex; flex-direction: column; justify-content: center; }

        .year-badge {
          position: absolute; top: 2rem; left: 2rem; 
          background: var(--primary); color: white; 
          padding: 0.5rem 1.5rem; border-radius: 1rem; 
          font-size: 1.5rem;
        }

        /* Footer CTA */
        .footer-cta { padding: 8rem 0; }
        .cta-card {
          background-color: var(--slate-900);
          color: white;
          border-radius: 5rem;
          padding: 6rem 2rem;
          text-align: center;
        }

        .cta-card h2 { font-size: clamp(3rem, 7vw, 6rem); margin-bottom: 2rem; line-height: 0.9; }
        .cta-card p { font-family: var(--font-body); font-size: 1.25rem; color: var(--slate-400); max-width: 50rem; margin: 0 auto 3rem; }

        /* Animations */
        .fade-in { animation: fadeIn 0.8s ease-out forwards; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }

        /* Footer */
        footer { padding: 5rem 0; border-top: 1px solid var(--slate-100); }
        .footer-inner { display: flex; flex-direction: column; gap: 3rem; }
        @media (min-width: 768px) { .footer-inner { flex-direction: row; justify-content: space-between; align-items: center; } }
      `}} />

      {/* Navbar */}
      <nav className={scrolled ? 'scrolled' : ''}>
        <div className="max-container nav-inner">
          <img src={icons.BussinesLogoV2} />

          <div className="nav-links">
            <NavLink href="#plataforma">Plataforma</NavLink>
            <NavLink href="#camiseta">A Camiseta</NavLink>
            <NavLink href="#historico">Histórico</NavLink>
            <a href="#contato" className="btn-nav">Quero ser apoiador</a>
          </div>

          <button className="mobile-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <IconX size={28} /> : <IconMenu size={28} />}
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="inicio" className="hero">
        <div className="max-container grid-2">
          <div className="fade-in">
            <div className="badge-hero">
              <IconBuilding size={16} />
              <span>Impacto Regional • Palmeira das Missões</span>
            </div>
            <img src={icons.LogoCapacita} className='logoCapacita' />
            <p className="hero-desc">
              O Projeto Capacita é uma iniciativa estratégica da Escola Newzape que prepara talentos locais para os desafios reais do mercado. Conectamos sua empresa a profissionais qualificados, reduzindo custos de treinamento e fortalecendo sua marca.
            </p>
            <div className="cta-group">
              <button className="btn-main primary">
                Quero ser apoiador <IconChevronRight size={22} />
              </button>
            </div>
          </div>

          <div className="camiseta-img-box fade-in" style={{animationDelay: '0.2s'}}>
            <img src={icons.CamisetaDeFrente} alt="Camiseta Projeto Capacita" />
          </div>
        </div>
      </section>

      {/* Nova Seção: Plataforma de Verificação e Certificação Premium */}
      <section id="plataforma" className="certificacao-premium">
        <div className="max-container">
          <div className="platform-container fade-in">
            <div className="platform-grid">
              <div className="platform-content">
                <span className="section-tag" style={{color: 'var(--secondary)'}}>Validação de Talentos</span>
                <h2>Certificação <br /><span style={{color: 'var(--primary)'}}>Premium.</span></h2>
                <p>
                  Criamos uma plataforma exclusiva onde o empregador pode consultar o certificado de cada aluno, visualizar a grade completa de cursos e garantir que o profissional realmente concluiu a formação.
                </p>
                <button className="btn-main outline" style={{color: 'white', borderColor: 'white', padding: '0.6rem 2.5rem', fontSize: '1.2rem'}} onClick={() => window.location.href = 'https://newzape.com.br/certificado'}>Consultar Certificado</button>
              </div>

              <div className="employer-perks">
                <div className="perk-card">
                  <div className="perk-header">
                    <div className="perk-icon"><IconSearch size={24} /></div>
                    <h3>Consulta Direta</h3>
                  </div>
                  <p>O empregador insere o código ou CPF e acessa instantaneamente o perfil acadêmico do candidato.</p>
                </div>
                
                <div className="perk-card">
                  <div className="perk-header">
                    <div className="perk-icon"><IconDatabase size={24} /></div>
                    <h3>Grade Curricular</h3>
                  </div>
                  <p>Visualize exatamente quais ferramentas de informática, vendas e atendimento o aluno domina.</p>
                </div>

                <div className="perk-card">
                  <div className="perk-header">
                    <div className="perk-icon"><IconShieldCheck size={24} /></div>
                    <h3>Garantia de Realização</h3>
                  </div>
                  <p>Sistema antifraude que valida se o curso foi cursado integralmente, com aprovação pedagógica da Newzape.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Camiseta Section */}
      <section id="camiseta" className="camiseta-section">
        <div className="max-container grid-2">
          <div className="camiseta-img-box">
             <img src={icons.CamisetaDeCostas} alt="Exposição na Camiseta" />
          </div>

          <div style={{display: 'flex', flexDirection: 'column', gap: '2rem'}}>
             <span className="section-tag">Visibilidade Urbana</span>
             <h2 className="section-title">Sua Marca <br /><span style={{color: 'var(--primary)', fontStyle: 'italic'}}>em Movimento.</span></h2>
             <p className="hero-desc">
               Ao apoiar o Projeto Capacita, sua logo é estampada nas camisetas oficiais usadas pelos alunos. Isso garante que sua marca circule diariamente pelos pontos mais estratégicos da cidade, associada à educação e progresso.
             </p>
             <div style={{background: 'white', padding: '2.5rem', borderRadius: '3rem', boxShadow: '0 10px 30px rgba(0,0,0,0.05)'}}>
                <h4 style={{fontSize: '1.8rem', marginBottom: '1rem', color: 'var(--primary)'}}>Destaque Institucional</h4>
                <p style={{fontFamily: 'var(--font-body)', color: 'var(--slate-600)'}}>Apareça como protagonista no desenvolvimento econômico de Palmeira das Missões.</p>
             </div>
          </div>
        </div>
      </section>

      {/* Histórico */}
      <section id="historico" className="historico">
        <div className="max-container">
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '5rem'}}>
            <div>
              <span className="section-tag">Legado</span>
              <h2 className="section-title">Edições <br /><span style={{color: 'var(--primary)', fontStyle: 'italic'}}>Anteriores.</span></h2>
            </div>
            <div className="slider-controls">
              <button className="slider-btn" onClick={prevSlide}><IconChevronLeft size={24} /></button>
              <button className="slider-btn" onClick={nextSlide} style={{backgroundColor: 'var(--primary)', color: 'white'}}><IconChevronRight size={24} /></button>
            </div>
          </div>

          <div className="slider-wrapper">
            <div className="slider-track" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
              {historySlides.map((slide, i) => (
                <div key={i} className="slide">
                  <div className="slide-content-box">
                    <div className="slide-img">
                       <img src={slide.image} alt={slide.title} />
                       <div className="year-badge">{slide.year}</div>
                    </div>
                    <div className="slide-text-side">
                       <h3 style={{fontSize: '3rem', marginBottom: '1.5rem', lineHeight: 1}}>{slide.title}</h3>
                       <p style={{fontSize: '1.15rem', color: 'var(--slate-600)', lineHeight: 1.6}}>{slide.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section id="contato" className="footer-cta">
        <div className="max-container">
          <div className="cta-card fade-in">
            <h2>Vamos qualificar <br /><span style={{color: 'var(--secondary)', fontStyle: 'italic'}}>nossa cidade?</span></h2>
            <p>Seja o motor de transformação que Palmeira das Missões precisa. Apoie o Projeto Capacita e colha os frutos de uma comunidade mais preparada.</p>
            <button className="btn-main primary" style={{background: 'var(--secondary)', padding: '1rem 5rem'}}>Quero ser apoiador</button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer>
        <div className="max-container footer-inner">
           <div className="logo-box">
             <div className="logo-icon"><IconAward size={20} /></div>
             <span className="logo-text">Newzape <span>Capacita</span></span>
           </div>
           
           <div style={{fontFamily: 'var(--font-accent)', textAlign: 'center', color: 'var(--slate-400)', fontWeight: 700, fontSize: '0.9rem'}}>
             Palmeira das Missões • RS <br /> © 2026 Todos os direitos reservados
           </div>

           <div style={{display: 'flex', gap: '2rem', fontSize: '1.1rem', fontFamily: 'var(--font-header)'}}>
             <a href="#" style={{color: 'inherit', textDecoration: 'none'}}>INSTAGRAM</a>
             <a href="#" style={{color: 'inherit', textDecoration: 'none'}}>WHATSAPP</a>
           </div>
        </div>
      </footer>
    </div>
  );
};

export default ProjetoCapacita;